export const getObjectPosition = (focalPoint?: [number, number]) => {
    return focalPoint ? `${focalPoint[0] * 100}% ${focalPoint[1] * 100}%` : undefined;
};
